export interface FormWerte {
  vorname: string
  nachname: string
  email: string
  /** optional: Unternehmen oder Verband - wird in Dynamics als Firma angelegt bzw. gefunden */
  organisation: string
  /** optional, Auswahl aus branchen bzw. funktionen */
  branche: string
  funktion: string
  einwilligung: boolean
}

export const leereWerte: FormWerte = { vorname: '', nachname: '', email: '', organisation: '', branche: '', funktion: '', einwilligung: false }

const PFLICHT_TEXT = {
  vorname: 'Bitte geben Sie Ihren Vornamen an.',
  nachname: 'Bitte geben Sie Ihren Nachnamen an.',
  email: 'Bitte geben Sie Ihre E-Mail-Adresse an.',
} as const

/** Meldungen erscheinen unter dem jeweiligen Feld - Klartext mit Handlungsanweisung. */
export function pruefe(werte: FormWerte): Record<string, string> {
  const fehler: Record<string, string> = {}
  for (const feld of ['vorname', 'nachname', 'email'] as const) {
    if (!werte[feld].trim()) fehler[feld] = PFLICHT_TEXT[feld]
  }
  const email = werte.email.trim()
  if (email && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) {
    fehler.email = 'Diese E-Mail-Adresse ist unvollständig.'
  }
  if (!werte.einwilligung) {
    fehler.einwilligung = 'Ohne Ihre Einwilligung können wir Ihre Anmeldung nicht bearbeiten.'
  }
  return fehler
}
